import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { makeRequest } from  'actions';
import { FETCH_METRO_AREAS, UPDATE_METRO_AREA,ADD_METRO_AREA,DELETE_METRO_AREA,} from "actions/actionTypes";
import config from  '../../../config';
 import { Button,Modal  } from 'react-bootstrap';
import {actionsFormatter }  from 'util/Utils';
import RemoveModalDialog from'shared/RemoveModalDialog';

class AdminMetroAreasList extends Component {
    constructor(props) {
        super(props);
        this.state={
            removeRecordModalVisible:false,
            currentRecord:false,
        }
        this.saveRecord = this.saveRecord.bind(this);
    }
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }
    componentWillMount() {
         if (!this.props.metroAreas.fetched) {
            var methodData = {
                "success_event": FETCH_METRO_AREAS,
                'endpoint': '/metro-areas',
                'not_display_success_message':true,

            };
            this.props.makeRequest({}, methodData);
        }
    }

    saveRecord(data) {
        var methodData = {
            type: 'post',
            "endpoint": "/metro-areas",
            'success_event_data': {
                'MetroAreaID': data.row._id
            },
            messageData: {'#1#': 'Product tag'},
            messageCode: 'recordAdded'
        };
        if (data.row._id.indexOf('autovalue') !== -1) { /* it is newly inserted row */
            methodData['success_event'] = ADD_METRO_AREA;
            this.props.makeRequest(data.row, methodData).catch(err => {
            });
        } else {
            methodData['success_event'] = UPDATE_METRO_AREA;
             methodData['type'] = 'patch';
            methodData['messageCode'] = 'recordUpdated';
            methodData['endpoint'] =  methodData['endpoint'] + '/'+ encodeURIComponent(data.row._id);
            var updateObject = {[data.cellName]: data.row[data.cellName]};
            this.props.makeRequest(updateObject, methodData).catch(err => {
            });
        }
    }


    renderShowsTotal(start, to, total) {
        return (
            <p >
                Showing { start } to { to } of { total } entries
            </p>
        );
    }
    showRemoveDialog(row){
        console.log('in show remove dialog', row,this.state);
        this.setState({removeRecordModalVisible:true,  currentRecord:row});
    }
     removeItem() {
          this.setState({removeRecordModalVisible:false});
    var methodData = {
        type: 'delete',
        "endpoint": "/metro-areas" + '/' + encodeURIComponent(this.state.currentRecord._id),
        'success_event_data': {
            'MetroAreaID': this.state.currentRecord._id
        },
        messageData: {'#1#': 'Metro area'},
        messageCode: 'recordDeleted'
    };
    this.setState({currentRecord:false});
    methodData['success_event'] = DELETE_METRO_AREA;
    this.props.makeRequest({}, methodData).then(function () {

    }).catch(err => {

    });
}
    editItem(row) {
        this.context.router.push(`/admin/metro-area/${encodeURIComponent(row._id)}/edit`)
    }
     arrayToTextFormatter (cell, row) {
          return (<div>{ (cell || []).join(', ') }</div>);
     }
    render() {
         console.log('state',this.state );

        return (
            <div className="admin-metro-area-list-page top20">

                <div className="databases-table">
                    <BootstrapTable data={this.props.metroAreas.data}
                                     hover={true}
                                    condensed={true}
                                    striped={true}
                                    pagination={true}
                                   search={true}
                                     options={{
                                        ...config.bootstrapTableOptions,
                                        paginationShowsTotal: this.renderShowsTotal,
                                      }}
                                   >
                        <TableHeaderColumn width="40px" dataField='Name'
                                           dataSort={true}>Name</TableHeaderColumn>
                        <TableHeaderColumn   dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                           hiddenOnInsert>Id</TableHeaderColumn>
                        <TableHeaderColumn width="180px" dataField='ZipCodes'
                                           dataFormat={this.arrayToTextFormatter}
                                            >Zip codes</TableHeaderColumn>
                        <TableHeaderColumn     columnClassName={'actions-column'}
                                            dataAlign="center" formatExtraData={ {   menuItemsMap : {Active:[
                            {onClick: 'editItem', label: 'Edit Metro Area'},
                            {onClick: 'showRemoveDialog', label: 'Remove Metro Area'}
                        ] },currentItem: 'Active' } }          dataFormat={ actionsFormatter.bind(this) } ></TableHeaderColumn>

                    </BootstrapTable>
                </div>
                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord = {(e) => this.removeItem() }
                    closeModal={(e) => this.setState({currentRecord: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>
             </div>
        );
    }
}


function mapStateToProps(state, props) {
    return {
        metroAreas: state.metroAreas
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({ makeRequest}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminMetroAreasList);
